(function ($) {
  "use strict";
  ally.style.focusSource();
})(jQuery);

// Helpers
const $win = jQuery(window);
const $body = jQuery("body");

// Disable Scroll

let isScrollDisabled = false;
let topScroll = 0;
const disabledScrollClass = "scroll-disabled";

function disableScroll() {
  if (!isScrollDisabled) {
    topScroll = $win.scrollTop();
    $body.css("top", `${-topScroll}px`).addClass(disabledScrollClass);
    isScrollDisabled = true;
  }
}

function enableScroll() {
  if (isScrollDisabled) {
    $body.removeAttr("style").removeClass(disabledScrollClass);
    $win.scrollTop(topScroll);
    isScrollDisabled = false;
  }
}

const errorClass = document.querySelector(".node-ind-generic-content");
if (errorClass) {
  if (errorClass.classList.contains("error-page")) {
    pushErrorPageEvent({});
  }
}
const body = document.body;
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
let lastScroll = 0;

window.addEventListener("scroll", () => {
  const currentScroll = window.pageYOffset;
  if (currentScroll <= 0) {
    body.classList.remove(scrollUp);
    return;
  }
  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    body.classList.remove(scrollUp);
    body.classList.add(scrollDown);
  } else if (
    currentScroll < lastScroll &&
    body.classList.contains(scrollDown)
  ) {
    body.classList.remove(scrollDown);
    body.classList.add(scrollUp);
  }
  lastScroll = currentScroll;
});
